export default __webpack_public_path__ + "assets/icons/homeBackground2.27e08037.svg";